import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'
import { DOWNLOAD_API } from '../../middleware/download.middleware'
import queryString from 'query-string'

/**
 * Contact Action Type Constants
 * @type {string}
 */
export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST'
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS'
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE'

export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST'
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS'
export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE'

export const SEARCH_CONTACT_REQUEST = 'SEARCH_CONTACT_REQUEST'
export const SEARCH_CONTACT_SUCCESS = 'SEARCH_CONTACT_SUCCESS'
export const SEARCH_CONTACT_FAILURE = 'SEARCH_CONTACT_FAILURE'

export const RESET_CONTACT_SEARCH = 'RESET_CONTACT_SEARCH'

export const DOWNLOAD_CONTACT_DATA_REQUEST = 'DOWNLOAD_CONTACT_DATA_REQUEST'
export const DOWNLOAD_CONTACT_DATA_SUCCESS = 'DOWNLOAD_CONTACT_DATA_SUCCESS'
export const DOWNLOAD_CONTACT_DATA_ERROR = 'DOWNLOAD_CONTACT_DATA_ERROR'

/**
 * Get contacts
 * @param params
 * @param options
 * @returns {{}}
 */
export const _getContacts = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_CONTACTS_REQUEST,
      GET_CONTACTS_SUCCESS,
      GET_CONTACTS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: (params.query && params.query.length) ? '/contacts/search' : '/contacts',
    payload: params
  }
})

/**
 * Get Contact
 * @param id - contact id
 * @param options
 * @private
 */
const _getContact = (id, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_CONTACT_REQUEST,
      GET_CONTACT_SUCCESS,
      GET_CONTACT_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/contact/${id}`
  }
})

/**
 * Search contacts
 * @param params
 * @param options
 * @returns {{}}
 */
export const _searchContacts = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      SEARCH_CONTACT_REQUEST,
      SEARCH_CONTACT_SUCCESS,
      SEARCH_CONTACT_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/contacts/search',
    payload: params
  }
})

/**
 * Download Contact Data to CSV
 * @param filters
 * @param file
 * @return {{}}
 * @private
 */
const _downloadContactData = ({ filters, file }) => ({
  [DOWNLOAD_API]: {
    endpoint: `/export?${queryString.stringify(filters)}`,
    types: [
      DOWNLOAD_CONTACT_DATA_REQUEST,
      DOWNLOAD_CONTACT_DATA_SUCCESS,
      DOWNLOAD_CONTACT_DATA_ERROR
    ],
    method: METHOD_TYPE.GET,
    payload: { file },
    options: {
      headers: {
        'Content-Type': 'text/csv'
      }
    }
  }
})

/**
 * Dispatch GET_CONTACTS_REQUEST
 * @param params
 * @param options
 * @returns {function(*): *}
 */
export const getContacts = (params, options) => (dispatch) => {
  return dispatch(_getContacts(params, options))
}

/**
 * Dispatch GET_CONTACT_REQUEST
 * @param id
 * @param options
 * @param options.types - action types
 */
export const getContact = (id, options) => (dispatch) => {
  return dispatch(_getContact(id, options))
}

/**
 * Dispatch SEARCH_CONTACT_REQUEST
 * @param params
 * @param options
 * @param options.types - action types
 */
export const searchContacts = (params, options) => (dispatch) => {
  return dispatch(_searchContacts(params, options))
}

/**
 * Dispatch RESET_CONTACT_SEARCH
 * @returns {function(*): *}
 */
export const clearSearchResults = () => (dispatch) => {
  return dispatch({ type: RESET_CONTACT_SEARCH })
}

/**
 * Dispatch DOWNLOAD_CONTACT_DATA_REQUEST
 * @param data
 * @return {function(*): *}
 */
export const downloadContactData = (data) => (dispatch) => {
  return dispatch(_downloadContactData(data))
}
